/* eslint-disable react/no-danger */
import React, { Component, PropTypes } from 'react';
import CSSModules from 'react-css-modules';
import styles from './Statement.css';

class Statement extends Component {
  static propTypes = {
    text: PropTypes.string,
    dropCap: PropTypes.bool,
    noColumns: PropTypes.bool,
    centered: PropTypes.bool,
  };

  render() {
    const { text, dropCap } = this.props;

    if (!text) {
      return null;
    }

    const isLongEnoughForColumns = this.props.noColumns ? false : text.length > 500 ;

    let styleName = 'statement';

    if (dropCap && isLongEnoughForColumns) {
      styleName = 'enable-with-columns-and-dropcap';
    } else if (dropCap) {
      styleName = 'statement-with-drop-cap';
    } else if (isLongEnoughForColumns) {
      styleName = 'statement-with-columns';
    }

    let styleAttribute = {};
    if (this.props.centered) {
      styleAttribute = {
        textAlign: 'center'
      };
    }

    return (
      <div
        style={styleAttribute}
        styleName={styleName}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    );
  }
}

export default CSSModules(Statement, styles, {
  errorWhenNotFound: false,
  allowMultiple: true,
});



// WEBPACK FOOTER //
// ./application/js/components/Statement.js